import {NewConversationComponent} from './components/new-conversation/new-conversation.component';
import {ConversationComponent} from './components/conversation/conversation.component';
import {ConversationListComponent} from './components/conversation-list/conversation-list.component';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {FieldConversationComponent} from './components/field-conversation/field-conversation.component';
import {ChatComponent} from './components/conversation-dialog/chat.component';
import {CollaborationConversationListComponent} from './components/collaboration-conversation-list/collaboration-conversation-list.component';
import {WaitingSupportConversationListComponent} from './components/waiting-support-conversation-list/waiting-support-conversation-list.component';
import {HelpSupportComponent} from './components/help-support/help-support.component';
import {SupportChatComponent} from './components/support-chat/support-chat.component';
import {CommentDialogComponent} from './components/comment-dialog/comment-dialog.component';
import {SupportCommentDialogComponent} from './components/comment-dialog/support-comment-dialog.component';
import {EditConversationListComponent} from './components/edit-conversation-list/edit-conversation-list.component';
import {DeleteConversationsDialogComponent} from './components/delete-conversations-dialog/delete-conversations-dialog.component';
import {ConversationAddContactComponent} from './components/conversation-add-contact/conversation-add-contact.component';
import {ChatSettingsDialogComponent} from './components/chat-settings-dialog/chat-settings-dialog.component';
import {SnippetComponent} from './components/snippet/snippet.component';
import {ActivitiesComponent} from './components/ActivityTracker/activities/activities.component';
import {ActivityFeedComponent} from './components/ActivityTracker/activity-feed/activity-feed.component';
import {ActivityComponent} from './components/ActivityTracker/activity/activity.component';
import {ActivityFilterCountrySelectorComponent} from './components/ActivityTracker/selector-dialogs/activity-filter-country-selector/activity-filter-country-selector.component';
import {ActivityFilterEntitySelectorComponent} from './components/ActivityTracker/selector-dialogs/activity-filter-entity-selector/activity-filter-entity-selector.component';
import {ActivityFilterProjectSelectorComponent} from './components/ActivityTracker/selector-dialogs/activity-filter-project-selector/activity-filter-project-selector.component';
import {ActivityFilterTransactionsSelectorComponent} from './components/ActivityTracker/selector-dialogs/activity-filter-transactions-selector/activity-filter-transactions-selector.component';
import {ActivityFilterCaseSelectorComponent} from './components/ActivityTracker/selector-dialogs/activity-filter-case-selector/activity-filter-case-selector.component';
import {ShareItemsComponent} from "@shared/components/share-items/share-items.component";
import {PinedHyperlinkCellViewerComponent} from './../../../features/data-survey/components/cell-viewers/pined-hyperlink-cell-viewer/pined-hyperlink-cell-viewer.component';
import {RoleSelectionComponent} from '@shared/components/role-selection/role-selection.component';
import {ReferenceNotificationSettingsComponent} from '@features/task-manager/collaboration/components/ActivityTracker/reference-notification-settings/reference-notification-settings.component';
import {ReactionTooltipComponent} from "./components/reaction-tooltip/reaction-tooltip.component";
import { MagicBarConversationComponent } from './components/magic-bar-conversation/magic-bar-conversation.component';


// @dynamic
export class CollaborationDynamicComponentHelper {
  public static components: any;

  public static init() {
    if (CollaborationDynamicComponentHelper.components) {
      return;
    }
    const components = {};

    components['NewConversationComponent'] = NewConversationComponent;
    components['ConversationComponent'] = ConversationComponent;
    components['ConversationListComponent'] = ConversationListComponent;
    components['WaitingSupportConversationListComponent'] = WaitingSupportConversationListComponent;
    components['FieldConversationComponent'] = FieldConversationComponent;
    components['CollaborationConversationListComponent'] = CollaborationConversationListComponent;
    components['chatComponent'] = ChatComponent;
    components['commentComponent'] = CommentDialogComponent;
    components['support-commentComponent'] = SupportCommentDialogComponent;
    components['HelpSupportComponent'] = HelpSupportComponent;
    components['SupportChatComponent'] = SupportChatComponent;
    components['EditConversationListComponent'] = EditConversationListComponent;
    components['DeleteConversationsDialogComponent'] = DeleteConversationsDialogComponent;
    components['ConversationAddContactComponent'] = ConversationAddContactComponent;
    components['ChatSettingsDialogComponent'] = ChatSettingsDialogComponent;
    components['SnippetComponent'] = SnippetComponent;
    components['ActivitiesComponent'] = ActivitiesComponent;
    components['ActivityFeedComponent'] = ActivityFeedComponent;
    components['ActivityComponent'] = ActivityComponent;
    components['CountrySelector'] = ActivityFilterCountrySelectorComponent;
    components['EntitySelector'] = ActivityFilterEntitySelectorComponent;
    components['ProjectSelector'] = ActivityFilterProjectSelectorComponent;
    components['TransactionSelector'] = ActivityFilterTransactionsSelectorComponent;
    components['CaseSelector'] = ActivityFilterCaseSelectorComponent;
    components['UserSelector'] = ShareItemsComponent;
    components['RoleSelectionComponent'] = RoleSelectionComponent;
    components['PinedHyperlinkCellViewerComponent'] = PinedHyperlinkCellViewerComponent;
    components['ReferenceNotificationSettingsComponent'] = ReferenceNotificationSettingsComponent;
    components['ReactionTooltipComponent'] = ReactionTooltipComponent;
    components['MagicBarConversationComponent'] = MagicBarConversationComponent;

    CollaborationDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static register(key: string, component: any) {
    CollaborationDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }

  public static getComponentArray(): any[] {
    CollaborationDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(CollaborationDynamicComponentHelper.components).forEach(key => {
      componentArray.push(CollaborationDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
}
